import { EMPTY_OBJECT } from '../../../../constants/common'
import { ComponentUsage } from '../ComponentUsage'

import * as styles from './ComponentLabel.module.css'

function ComponentLabel({
  Element = 'div',
  Name = 'h2',
  Usage = ComponentUsage,
  className = styles.ComponentLabel,
  name,
  nameProps: {
    className: nameClassName = styles.name,
    ...nameProps
  } = EMPTY_OBJECT,
  props = EMPTY_OBJECT,
  ...elementProps
}) {
  return (
    <Element {...elementProps} className={className}>
      <Name {...nameProps} className={nameClassName}>
        {name}
      </Name>
      <Usage name={name} value={props} />
    </Element>
  )
}

export default ComponentLabel
